var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.421 7.579H7.579v16.842h16.842z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M24.421 32 32 24.421l-3.789-.646-3.789.646-.692 3.466z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.421v5.053A2.525 2.525 0 0 0 2.526 32h5.053l.778-3.789-.778-3.789-4.129-.648z",
    fill: "#188038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 7.579V2.526A2.525 2.525 0 0 0 29.474 0h-5.053q-.692 2.819-.692 4.149t.692 3.429q2.514.72 3.789.72T32 7.579",
    fill: "#1967D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M32 7.579h-7.579v16.842H32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M24.421 24.421H7.579V32h16.842z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.421 0H2.526A2.525 2.525 0 0 0 0 2.526v21.895h7.579V7.579h16.842z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.034 20.644q-.944-.636-1.304-1.867l1.461-.602q.199.758.695 1.175.494.416 1.196.415.717 0 1.232-.436t.516-1.109q0-.689-.543-1.124-.544-.435-1.36-.436h-.844v-1.446h.758q.701 0 1.181-.379t.48-1.038q0-.587-.429-.936-.429-.351-1.089-.351-.644 0-1.023.343a2 2 0 0 0-.551.844l-1.446-.602q.287-.815 1.059-1.438c.772-.623 1.175-.623 1.975-.623q.887 0 1.596.343.708.345 1.109.952.401.609.4 1.366 0 .773-.372 1.31c-.372.536-.553.631-.916.823v.086a2.8 2.8 0 0 1 1.175.916q.459.615.459 1.474t-.436 1.532q-.437.674-1.202 1.059-.767.387-1.724.388a3.56 3.56 0 0 1-2.05-.636m8.975-7.25-1.604 1.16-.802-1.216 2.878-2.076h1.103v9.791h-1.575z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarLogo);
export default __webpack_public_path__ + "static/media/google-calendar-logo.e81621f98f70300c520f4dcfbda13659.svg";
export { ForwardRef as ReactComponent };